import { CellContext } from "@/lib/Components/DataTable/types";
import { WaitlistListItem } from "@/app/Waitlists/GraphQL/waitlistListQuery";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { cn } from "@/lib/utils";

export function WaitlistMatchesCell({
  row,
}: CellContext<WaitlistListItem, any>) {
  return (
    <a
      href={row.original.relocationLink}
      target="_blank"
      className={cn("flex items-center space-x-2 text-blue-500 underline", {
        "text-blue-500": row.original.relocations_count > 0,
        "text-gray-500": row.original.relocations_count === 0,
      })}
      rel="noreferrer"
    >
      <span>{row.original.relocations_count}</span>
      <ArrowTopRightOnSquareIcon className="h-4 w-4" />
    </a>
  );
}
